// extracted by mini-css-extract-plugin
export default {"labelRange":"styles_labelRange__xb5hs","fullInput":"styles_fullInput__TnZ22"};